import React from 'react';
import './Header.css';
import Button from '../Button';


const LOCAL_STORAGE_KEY = "org.unajs.savedwork";

export default function Header(props) {
  const {cards, setCards} = props;

  const saveWork = () => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({time: (new Date()).getTime(), cards}));
    alert('Your work is saved locally in your browser.');
  };

  const loadWork = () => {
    const loadedData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
    setCards(loadedData.cards);
  }

  return (
    <div className="header-container">
      Visualizer
      <div className="header-button-container">
        <Button label="Load Saved Work" onClick={loadWork} style={{marginRight: 20}} />
        <Button label="Save Your Work" onClick={saveWork} />
        <a className="header-additional-text" href="https://a16.xyz" target="_blank" rel="noopener noreferrer">
          by a16.xyz
        </a>
      </div>
    </div>
  );
}
